<c-card *transloco="let t">
    <c-card-body *ngIf="users">

        <c-container class="px-2">
            <c-row>
              <c-col md="6">
                  <h1>{{ t('Import Workers from Geotab') }}</h1>
                  <p>{{ t('Please use this page to import users from your Geotab account into OK Alone as workers.') }}</p>
              </c-col>
              <c-col md="6">

                <form class="row gy-2 gx-3 align-items-center">
                  <div class="col-auto">
                    <div class="input-group">
                      <span class="input-group-text" id="basic-addon1"><i class="fas fa-search"></i></span>
                      <input cFormControl id="search" name="search" [(ngModel)]="search" placeholder="{{ t('Enter a user email') }}" />
                    </div>
                  </div>
                  <div class="col-auto">
                    <button type="submit" class="btn btn-primary my-2 me-2" (click)="doSearch()">{{ t('Email') }} {{t('Search')}}</button>
                    <button type="submit" class="btn  btn-light my-2" (click)="cancelSearch()"><i class="fas fa-times"></i></button>
                  </div>
                </form>

              </c-col>
            </c-row>



            <c-row *ngIf="users">
              <c-col>

                <div class="alert alert-info" role="alert" *ngIf="users.length==250">
                  {{ t('We can only show a maximum of 250 users here. If you have more please search for their email in the box above.') }}
                </div>

                <table
                [hover]="true"
                [responsive]="true"
                [striped]="true"
                align="middle"
                cTable
                class="mb-0 border"
                >
                  <thead>
                    <tr>
                      <th scope="col"></th>
                      <th scope="col">{{ t('Monitor') }}</th>
                      <th scope="col">{{ t('Email') }} / {{ t('Phone') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let user of users">
                        <td>
                          <button color="success" cButton class="me-1 btn-sm text-white" *ngIf="user.is_worker">
                            <i class="fa-solid fa-check"></i>
                            {{ t('Imported') }}
                          </button>
                          <button  cButton class="me-1 btn-sm  text-white btn-info" (click)="importWorker(user)" *ngIf="!user.is_worker">
                            <i class="fa-solid fa-file-import"></i>
                            {{ t('Import') }}
                          </button>
                        </td>
                        <td>
                          <span><b>{{user.name}}</b></span>
                        </td>
                        <td>
                          {{user.email}}
                          <div class="small text-medium-emphasis">
                            <span>{{user.phone}}</span>
                          </div>
                        </td>
                        <td>

                      </tr>
                    </tbody>

                </table>

              </c-col>
            </c-row>

          </c-container>

    </c-card-body>
  </c-card>
